import React, { useEffect, useState } from 'react';
import { UiComponents } from "@simulanisindia/ui";
import { GROUP_TAB_TYPE, RESOURCE_APPLICATION_TAB, RESOURCE_ENVIRONMENT_TAB, RESOURCE_MODULE_TAB, RESOURCE_SKILL_SCHOOL_TAB, RESOURCE_SKILL_STREAM_TAB, statusOptions, USER_TAB_TYPE } from '../constant/constants';
import { useSelector } from 'react-redux';
import FilterTab from '../pages/ResourceManagement/FilterTab';



// const { FilterTab } = UiComponents;

const FilterOption = ({ showfilter, selectedCheckboxes, activeTab, onToggleFilter, handleResetCheckBox, handleSelectCheckbox }) => {

    const moduleSlice = useSelector((state) => state.moduleFilterSlice);
    const configSlice = useSelector((state) => state.configSlice);
    const applicationData = useSelector((state) => state.applicationSlice);
    const [filterCategoryOption, setFilterCategoryOption] = useState({
        [RESOURCE_APPLICATION_TAB]: [],
        [RESOURCE_MODULE_TAB]: [],
        [RESOURCE_ENVIRONMENT_TAB]: [],
        [RESOURCE_SKILL_STREAM_TAB]: [],
        [RESOURCE_SKILL_SCHOOL_TAB]: [],
        [GROUP_TAB_TYPE]: [],
        [USER_TAB_TYPE]: [],
    });

    useEffect(() => {
        const mapRoles = (roles) => roles.map(({ id, name }) => ({ value: id, name, key: name, type: "role" }));

        let resourceFilterOption = moduleSlice?.allModuleCategory?.children?.map((category) => ({
            name: category.name,
            tags: category.tags.map((tag) => ({
                name: tag.name,
                key: tag.id,
                value: tag.id,
                id: tag.id,
                type: (category.name).replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase()
            })),
        }));

        let environmentFilterOption = applicationData?.environmentTypes?.children?.map((category) => ({
            name: category.name,
            tags: category.tags.map((tag) => ({
                name: tag.name,
                key: tag.id,
                value: tag.id,
                id: tag.id,
                type: (category.name).replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase()
            })),
        }));

        let appCategory = applicationData?.applicationsCategory?.tags || [];
        let applicationFilterOptions = [
            {
                name: "Category",
                tags: appCategory.map((tag) => ({
                    name: tag.name,
                    key: tag.id,
                    value: tag.id,
                    id: tag.id,
                    type: "Category".replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase()
                })),
            },
        ];

        let skillStreamFilterOptions = applicationData?.skillStreamCategory?.children?.map((category) => ({
            name: category.name,
            tags: category.tags.map((tag) => ({
                name: tag.name,
                key: tag.id,
                value: tag.id,
                id: tag.id,
                type: category.name.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase(),
            })),
        }));

        setFilterCategoryOption((pre) => ({
            ...pre,
            [RESOURCE_MODULE_TAB]: resourceFilterOption,
            [RESOURCE_APPLICATION_TAB]: applicationFilterOptions,
            [RESOURCE_ENVIRONMENT_TAB]: environmentFilterOption,
            [GROUP_TAB_TYPE]: [
                {
                    name: "Status",
                    tags: statusOptions,
                },
                {
                    name: "Group types",
                    tags: mapRoles(configSlice.groupTypes),
                },
            ],
            [USER_TAB_TYPE]: [
                {
                    name: "Status",
                    tags: statusOptions,
                },
                {
                    name: "Roles",
                    tags: mapRoles(configSlice.roles),
                },
            ],
            [RESOURCE_SKILL_SCHOOL_TAB]: resourceFilterOption,
            [RESOURCE_SKILL_STREAM_TAB]: skillStreamFilterOptions,
        }));

    }, [applicationData, configSlice, moduleSlice]);

    const resetCheckBox = () => {
        if (handleResetCheckBox) {
            handleResetCheckBox();
        }
    }

    const handleSelectItem = (e, isCategory = false) => {
        if (handleSelectCheckbox) {
            handleSelectCheckbox(e, isCategory);
        }
    }

    const handOpenFilter = () => {
        if (onToggleFilter) {
            onToggleFilter();
        }
    }


    return (
        <>
            <FilterTab
                showfilter={showfilter}
                selectedCheckboxes={selectedCheckboxes}
                setSelectedCheckboxes={handleSelectItem}
                filterOptions={filterCategoryOption[activeTab] || []}
                onToggleFilter={handOpenFilter}
                handleResetCheckBox={resetCheckBox}
                categoryOptions={activeTab === "moduleTab" ?
                    (moduleSlice?.tagCategoryList?.length === 1
                        ? moduleSlice?.tagCategoryList[0]
                        : moduleSlice?.tagCategoryList) || null
                    : null}
            />
        </>
    )
}

export default FilterOption;